require('./insuranceLandingView.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { connect } = require('react-redux');
const moment = require('moment');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const UrlHelper = require('utilities/urlHelper');
const {
    toCamelCase,
} = require('utilities/stringHelper');
const { recordCommercialSpaceV2 } = require('utilities/tagging');
// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKModal = require('components/commons/OKModal/OKModal');
// @ components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const InsurancesProductBanners = require('../../../components/insurancesLanding/insurancesProductBanners/insurancesProductBanners');
const InsurancesStatusWaffer = require('../../../components/insurancesLanding/insurancesStatusWaffer/insurancesStatusWaffer');
const InsuranceStatusAlternativeWaffer = require('../../../components/insurancesLanding/InsurancesStatusAlternativeWaffer/InsurancesStatusAlternativeWaffer');
const InsurancesActiveProducts = require('../../../components/insurancesLanding/insurancesActiveProducts/insurancesActiveProducts');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
// @ actions
const insuranceRequestStateActions = require('../../../actions/insuranceRequest/insuranceRequestState');
const insuranceRequestSimulationActions = require('../../../actions/insuranceRequest/insuranceRequestSimulation');
const insurancesLandingActions = require('../../../actions/insuranceRequest/insuranceRequestLanding');
// @ constants
const { GRAPHIC_TUTOR_TYPE_8 } = require('constants/index');
const {
    MAX_DAYS_INSURANCE_ASSOCIATED,
    PRODUCT_BANNERS_MARGIN_TOP,
    TOPBAR_DEFAULT_HEIGHT,
} = require('../../../insuranceConstants/insuranceRequestHome');
const { INSURANCES_HOME_REQUEST } = require('../../../insuranceConstants/insuranceRequestRoutes');
const {
    COMMERCIAL_MOBILE_INSURANCE,
    LIFE_INSURANCE_WAFER,
    INSURANCE_LANDING_DISCRIMINATION,
    INSURANCE_ADS_CIRCULAR,
} = require('constants/flagBasedFeatures');
const {
    PRODUCT_TYPE: {
        HOME,
        MOBILE_INSURANCE,
    },
} = require('../../../insuranceConstants/insuranceRequestTypes');
const INSURANCES_PRODUCT_BANNERS = require('constants/productBanners/insurancesProductBanners');
const {
    ACTION_EVENT_VIEW,
    COMMERCIAL_ADS_TEALIUM_EVENT,
    COMMERCIAL_WAFER_ADS_EVENT_CATEGORY,
} = require('constants/tagging');
const {
    INSURANCE_HOME,
    ROBO_MOVIL,
    INSURANCE_LIFE,
} = require('../../../insuranceConstants/insurancesProductBanners');

class InsuranceLandingView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpened: true
        };

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleCancelOnWafer = this.handleCancelOnWafer.bind(this);
        this.handleContinueOnWafer = this.handleContinueOnWafer.bind(this);
        this.handleModalRecover = this.handleModalRecover.bind(this);
        this.handleModalContinue = this.handleModalContinue.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.scrollToProductBanners = this.scrollToProductBanners.bind(this);
    }

    componentDidMount() {
        const { getInsurance, requestInsurancesOverallView } = this.props;

        getInsurance();
        requestInsurancesOverallView();
        this.handleInsuranceBannerTaggings();

        scrollToTop();
    }

    handleInsuranceBannerTaggings() {
        const { immInsuranceState, immFlagBasedFeatures } = this.props;
        const taggingParams = {
            categoriaEvento: '',
            accionEvento: ACTION_EVENT_VIEW,
            tealiumEvent: COMMERCIAL_ADS_TEALIUM_EVENT,
        };
        const taggingCustomData = {
            promotion_id: [],
            promotion_name: [],
            promotion_creative: [],
            promotion_position: [],
        };
        const wafersIds = [];
        const hasSimulationStarted = !!immInsuranceState.getIn(['data', 'createdAt']);
        const showRoboMovilBanner = immFlagBasedFeatures.get(COMMERCIAL_MOBILE_INSURANCE);
        const showLifeBanner = immFlagBasedFeatures.get(LIFE_INSURANCE_WAFER);

        Object.keys(INSURANCES_PRODUCT_BANNERS).forEach((bannerKey) => {
            const bannerData = INSURANCES_PRODUCT_BANNERS[bannerKey];
            const showBanner = (bannerKey === INSURANCE_HOME && !hasSimulationStarted) || (bannerKey === ROBO_MOVIL && showRoboMovilBanner);
            if (showBanner) {
                taggingCustomData.promotion_id.push(bannerData.id);
                taggingCustomData.promotion_name.push(bannerData.id);
                taggingCustomData.promotion_creative.push(formatText(bannerData.title));
                taggingCustomData.promotion_position.push(
                    (bannerKey === INSURANCE_HOME && !hasSimulationStarted)
                        ? bannerData.promotionPosition
                        : (bannerKey === ROBO_MOVIL && showRoboMovilBanner && !hasSimulationStarted)
                        ? bannerData.promotionPosition
                        : (bannerKey === INSURANCE_LIFE && showLifeBanner && !hasSimulationStarted)? bannerData.promotionPosition:'1'

                );
                wafersIds.push(bannerData.id);
            }
        });
        if (wafersIds.length) {
            taggingParams.categoriaEvento = `${COMMERCIAL_WAFER_ADS_EVENT_CATEGORY}${wafersIds.join(', ')}`;
            recordCommercialSpaceV2(taggingParams, taggingCustomData);
        }
    }

    getMenuHeightSize() {
        const menu1 = document.getElementsByClassName('openbank-topbar--with-private-menu')[0];
        const menu1Height = menu1.offsetHeight || 0;
        const menu2 = document.getElementsByClassName('private-menu__nav')[0];
        const menu2Height = menu2.offsetHeight || 0;
        return (menu1Height + menu2Height);
    }

    handleCancelOnWafer() {
        this.props.cancelSimulation();
    }

    handleContinueOnWafer() {
        this.props.getInsurance().then(() => {
            this.props.history.push(formatText('insuranceLanding-insuranceOfferProcessContinueLinkURL'));
        });
    }

    handleContinueOnAlternativeWafer() {
        this.props.cancelSimulation().then(() => {
            this.props.history.push(INSURANCES_HOME_REQUEST);
        });
    }

    handleModalRecover() {
        this.props.resetSimulation();
        UrlHelper.scrollTo(this._userCurrentSimulation);
        const currentMenuSize = this.getMenuHeightSize()
        const currentTop = window.scrollY;
        if (currentTop > currentMenuSize) {
            window.scrollTo(0, currentTop - currentMenuSize);
        }
    }

    handleModalContinue() {
        const { cancelSimulation, immInsuranceSimulation, history } = this.props;
        cancelSimulation(immInsuranceSimulation.get('token'), history);
    }

    handleCloseModal() {
        this.setState({
            modalOpened: false
        });
    }

    buildGraphicTutor() {
        const tutorialTitle = formatText('tutorials-insurancesTitle');

        return (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_8}
                title={tutorialTitle}
            />
        )
    }

    buildInsuranceStatusWaferContent() {
        const { immInsuranceState } = this.props;

        const insuranceState = immInsuranceState.getIn(['data', 'insuranceState']);
        let content = null;

        if (!insuranceState) {
            content = null;
        } else if (immInsuranceState.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const isLimitsFlagEnabled = immInsuranceState.getIn(['data', 'ccLimitsFlag']);
            if (isLimitsFlagEnabled && !__CONTACT_CENTER__) {
                content = this.buildInsuranceStatusAlternativeWaffer();
            } else {
                content = this.buildInsuranceStatusWaffer();
            }
        }

        return content;
    }

    buildInsuranceStatusAlternativeWaffer() {
        return (
            <InsuranceStatusAlternativeWaffer
                onCancel={this.handleCancelOnWafer}
                onContinue={this.handleContinueOnAlternativeWafer}
                innerRef={ref => this._userCurrentSimulation = ref}
            />
        )
    }

    buildSimulationDays() {
        const { immInsuranceState } = this.props;

        const today = moment(new Date());
        const simulationDate = moment(immInsuranceState.getIn(['data', 'createdAt']));
        const diffDays = moment.duration(today.diff(simulationDate));
        return MAX_DAYS_INSURANCE_ASSOCIATED - parseInt(diffDays.asDays());
    }

    buildInsuranceStatusWaffer() {
        const daysSinceSimulation = this.buildSimulationDays();

        return (
            <InsurancesStatusWaffer
                days={daysSinceSimulation}
                onCancel={this.handleCancelOnWafer}
                onContinue={this.handleContinueOnWafer}
                innerRef={ref => this._userCurrentSimulation = ref}
            />
        )
    }

    sortInsurances() {
        const {
            immInsurances,
        } = this.props;

        return immInsurances.get('insurances').sort((a, b) => {
            if (a.get('effectiveDate') === b.get('effectiveDate')) {
                return a.get('policyNumber').localeCompare(b.get('policyNumber'), 'kn');
            } else {
                return a.get('effectiveDate').localeCompare(b.get('effectiveDate'));
            }
        });
    }

    scrollToProductBanners() {
        const element = this.productBannersRef;

        if (element) {
            element.scrollIntoView();
            const scrolledY = window.scrollY;

            if (scrolledY) {
                const topbar = document.getElementsByClassName('ok-topbar')[0];
                const topbarHeight = !!topbar ? topbar.clientHeight : TOPBAR_DEFAULT_HEIGHT;
                const positionY = scrolledY - (topbarHeight + PRODUCT_BANNERS_MARGIN_TOP);
                window.scrollTo(0, positionY);
            }
        }
    }

    filterInsurances(immInsurances, productName) {
        return immInsurances.filter(immInsurance => immInsurance.get('productName') === productName);
    }

    buildActiveInsurancesList(immSortedInsurances, productName) {
        const {
            immFlagBasedFeatures,
            immInsurances,
            immInsuranceState,
            immLoans,
            requestInsurancesOverallView,
        } = this.props;

        const hasOpenInsurances = immInsuranceState.get('data') !== null;
        const landingDiscriminationEnabled = immFlagBasedFeatures.get(INSURANCE_LANDING_DISCRIMINATION);
        const immInsurancesList = landingDiscriminationEnabled ? this.filterInsurances(immSortedInsurances, productName) : immSortedInsurances;
        const hasInsurances = immInsurancesList.size !== 0;
        const hasError = immInsurances.get('error');
        const titleKeySufix = toCamelCase(productName.replace('_', ' ')).replace(' ', '');
        const titleKey = landingDiscriminationEnabled ? `insuranceLanding-insuranceLanding_title${titleKeySufix}` : 'insuranceLanding-title';
        const title = formatText(titleKey);

        let content;

        if (immInsurances.get('isFetching')) {
            content = <LoadingSection />
        } else {
            content = hasInsurances || hasError ? (
                <InsurancesActiveProducts
                    error={hasError}
                    expanded={true}
                    handleErrorRetry={requestInsurancesOverallView}
                    handleLinkClick={this.scrollToProductBanners}
                    hasOpenInsurances={hasOpenInsurances}
                    id={`insurancesActiveProducts_${productName}`}
                    immInsurances={immInsurancesList}
                    immLoans={immLoans}
                    title={title}
                />
            ) : null;
        }

        return content;
    }

    buildProductBannerList() {
        const {
            immFlagBasedFeatures,
            immInsuranceState,
        } = this.props;

        if (immInsuranceState.get('isFetching')) {
            return <LoadingSection />;
        }

        const hasSimulationStarted = !!immInsuranceState.getIn(['data', 'createdAt']);

        return (
            <div ref={productBanners => this.productBannersRef = productBanners}>
                <InsurancesProductBanners
                    hasSimulationStarted={hasSimulationStarted}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                />
            </div>
        );
    }

    buildModalDeleteCurrentSimulation() {
        const { immInsuranceSimulation } = this.props;

        const linkError = immInsuranceSimulation.get('error');
        const isFetching = immInsuranceSimulation.get('isFetching') || immInsuranceSimulation.get('isFetchingCancel');

        if (linkError && linkError.get('status') === 422) {
            return (
                <OKModal
                    description="insuranceLanding-modalSubtitle"
                    descriptionAlignment="center"
                    footerType="action"
                    isOpen={this.state.modalOpened}
                    onCloseCallback={this.handleCloseModal}
                    onPrimaryButtonClick={this.handleModalContinue}
                    onSecondaryButtonClick={this.handleModalRecover}
                    primaryButtonLoading={isFetching}
                    primaryButtonText="insuranceLanding-modalContinue"
                    secondaryButtonText="insuranceLanding-modalRecover"
                    title="insuranceLanding-modalTitle"
                    titleAlignment="center"
                />
            );
        }
    }

    buildMsgPrivate() {
        return (
            <OKMessage
                title={formatText("insuranceLanding-insuranceLanding_title")}
                type="informative"
            >
                <FormattedText value="insuranceLanding-insuranceLanding_info" />
            </OKMessage>
        )
    }

    buildMsgCC() {
        return (
            <BlockInfo>
                {formatText('insuranceLanding-insuranceLanding_info')}
            </BlockInfo>
        )
    }

    buildLegalInfo() {
        let { immFlagBasedFeatures } = this.props;
        let legalInfo = __CONTACT_CENTER__
            ? this.buildMsgCC()
            : this.buildMsgPrivate();

        return !!immFlagBasedFeatures.get(INSURANCE_ADS_CIRCULAR) && (
            <div className="row mt-20">
                <div className="col-md-12">{legalInfo}</div>
            </div>
        );
    }

    render() {
        const {
            immFlagBasedFeatures,
            match,
        } = this.props;

        const commercialBannerB = !__CONTACT_CENTER__ ? <CommercialAds path={match.path} type="banner-b" /> : null;
        const comercialCrossSelling = !__CONTACT_CENTER__ ? <CommercialAds path={match.path} type="cross-selling" /> : null;
        const immSortedInsurances = this.sortInsurances();
        const activeInsurancesList = this.buildActiveInsurancesList(immSortedInsurances, HOME);
        const movilInsurancesList = immFlagBasedFeatures.get(INSURANCE_LANDING_DISCRIMINATION) ? this.buildActiveInsurancesList(immSortedInsurances, MOBILE_INSURANCE) : null;

        return (
            <React.Fragment>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderLanding
                                title={formatText('insuranceLanding-title')}
                                tutorial={this.buildGraphicTutor()}
                                inputClassName="ok-header-landing--insurances"
                        />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid grid-view--content-position-positive">
                        <div className="row">
                            <div className="col-xs-12 col-md-9">
                                <div className="row">
                                    <div className="col-md-12">
                                        {activeInsurancesList}
                                        {movilInsurancesList}
                                        {this.buildInsuranceStatusWaferContent()}
                                        {this.buildProductBannerList()}
                                    </div>
                                </div>
                                {this.buildLegalInfo()}
                            </div>
                            <div className="col-xs-12 col-md-3">
                                <div className="row">
                                    <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                                        {commercialBannerB}
                                    </div>
                                    <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                                        <CallMeBack isSmall={true} hasEntrance={false}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid grid-view__cross-selling">
                    <div className="row">
                        {comercialCrossSelling}
                    </div>
                </div>
                {this.buildModalDeleteCurrentSimulation()}
            </React.Fragment>
        );
    }
}

InsuranceLandingView.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immInsurances: PropTypes.object.isRequired,
    immInsuranceState: PropTypes.object.isRequired,
    immInsuranceSimulation: PropTypes.object.isRequired,
    immLoans: PropTypes.object.isRequired,
    requestInsurancesOverallView: PropTypes.func.isRequired,
    clearInsurancesOverallView: PropTypes.func.isRequired,
    cancelSimulation: PropTypes.func.isRequired,
    resetSimulation: PropTypes.func.isRequired,
    getInsurance: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immInsuranceState: state.insuranceRequestState,
        immInsurances: state.insuranceRequestLanding,
        immInsuranceSimulation: state.insuranceRequestSimulation,
        immLoans: state.loans
    }), {
    getInsurance: insuranceRequestStateActions.requestInsuranceCurrentState,
    cancelSimulation: insuranceRequestSimulationActions.cancelSimulation,
    resetSimulation: insuranceRequestSimulationActions.resetSimulation,
    requestInsurancesOverallView: insurancesLandingActions.requestInsurancesOverallView,
    clearInsurancesOverallView: insurancesLandingActions.clearInsurancesOverallView
}
)(InsuranceLandingView));
